import React, { Component } from 'react';
import 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.css';
import { compose } from 'redux';
import { connect } from 'react-redux';

import galleryOpenImage from '../images/gallery-open.svg';
import { inIframe, postMessageToParent } from '../utils';

class PackageGallery extends Component {

	getGalleryId = () => 'package-' + this.props.id;

	initLightGallery = ref => {
		this.lightGallery = ref;

		if (!ref) return;

		if (inIframe()) {
			postMessageToParent('loadLightGallery', {
				id: this.getGalleryId(),
				photos: this.props.photos.map(photo => window.location.origin + photo.original)
			});
		} else {
			window.lightGallery(ref, {
				download: false
			});
		}
	};

	componentWillUnmount() {
		if (inIframe()) {
			postMessageToParent('unloadLightGallery', { id: this.getGalleryId() });
		} else {
			// Unmount lightgallery.js
			if (this.lightGallery && this.lightGallery.getAttribute('lg-uid') && window.lgData) {
				window.lgData[this.lightGallery.getAttribute('lg-uid')].destroy();
			}
		}
	}

	onClick = (e, index) => {
		if (inIframe()) {
			e.preventDefault();
			postMessageToParent('openLightGallery', { id: this.getGalleryId(), index: index });
		}
	};

	render() {
		const { photos, apiOrigin, alt } = this.props;

		return (
			<div className="step3-package__gallery" ref={this.initLightGallery}>
				{photos.map((photo, index) => (
					<a
						href={apiOrigin + photo.large}
						className={`${index >= 5 ? 'hidden' : ''} step3-package__photo-container`}
						key={index}
						onClick={e => this.onClick(e, index)}
					>
						{index < 5 &&
						<React.Fragment>
							<div
								className="step3-package__photo"
								style={{ backgroundImage: `url(${apiOrigin}${photo.medium})` }}
							/>
							{index === 0 &&
							<img src={galleryOpenImage} alt={alt} className="step3-package__photo-gallery-open" />
							}
						</React.Fragment>
						}
					</a>
				))}
			</div>
		);
	}
}

export default compose(
	connect((state) => ({
		apiOrigin: state.app.apiOrigin,
	})),
)(PackageGallery);



// WEBPACK FOOTER //
// ./src/components/PackageGallery.jsx